/**
 * Shared HTTP header names used by both the browser API client and the backend.
 * Kept here (rather than in api-client.ts) so the server can import the constant
 * without pulling in the whole client module and its dependencies.
 */

/**
 * Header the browser sends while an admin is in "fake user mode". The backend
 * downgrades the request to a non-admin view when it sees this header set to
 * 'true'. See the gears-api authentication middleware and the api-client.
 */
export const FAKE_USER_HEADER = 'racemap-fake-user';
